<template>
  <div class="production-container">
    <div class="t-top-bar">
      <el-input placeholder="请输入内容" v-model="listQuery.keyword" class="input-with-select search-input">
        <el-button  slot="append"  type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
      </el-input>
      <el-select class="search-option" v-model="listQuery.type" @change="searchChange" placeholder="适用终端类型" style="width: 120px">
        <el-option label="全部" :value="-1"></el-option>
        <el-option v-for="(val,key) in selectDic('EQUIP_TYPE')" :key="key" :label="val.name" :value="val.code"></el-option>
      </el-select>
      <div class="btns">
        <a title="导入模板下载" href="/productImport.xlsx" download="产品规格工艺价格导入模板">导入模板下载</a>
        <el-upload v-if="authedCheck('导入产品')" title="导入产品"
                   class="upload-demo" :data="uploadParam"
                   :action="uploadUrl" :show-file-list="false"
                   :multiple="false" :on-success="uploadHandler" :on-progress="uploadProgressHandler">
          <el-button type="primary">导入</el-button>
        </el-upload>
        <el-button type="primary" v-if="authedCheck('添加产品')" title="添加产品" @click="addHandler">添加</el-button>
        <el-button style="margin: 0" type="primary" v-if="authedCheck('产品信息同步')" title="产品信息同步" @click="dispatchHandler">同步</el-button>
      </div>
    </div>
    <el-table :data="tableData" border style="width: 100%" v-loading="listLoading" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="productionId" label="产品编号" width="100"></el-table-column>
      <el-table-column prop="productionName" label="产品名称"></el-table-column>
      <el-table-column prop="createTime" label="添加时间">
          <template slot-scope="scope">
              {{scope.row.createTime | formateTime()}}
          </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <i class="el-icon-edit el-icon-table btn-primary" v-if="authedCheck('编辑产品')" title="编辑产品"
             @click="editHandler(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>


    <el-dialog :title="opFlag=='add'?'添加产品':'修改产品'" :visible.sync="addDialogVisiable"
               @close="addCloseHandler"  width="650px">
      <el-form :model="addForm" :rules="rules" ref="addForm">
        <el-form-item label="产品名称" prop="productionName" :label-width="formLabelWidth">
          <el-input v-model="addForm.productionName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="适用终端类型" prop="type" :label-width="formLabelWidth">
          <el-select :disabled="opFlag=='edit'" v-model="addForm.type" placeholder="请选择适用终端类型">
            <el-option v-for="(val,key) in selectDic('EQUIP_TYPE')" :key="key" :label="val.name" :value="val.code"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisiable = false">取 消</el-button>
        <el-button type="primary" @click="addConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <DispatchDialog ref="dispatchDialog" :dispatchType="3" :equipmentType="this.listQuery.type" :select-data-ids="selectIds"></DispatchDialog>
  </div>
</template>

<script>
    import { addProduction,updateProduction,getProductionList } from '../../api/prouction'
    import localCache from "../../util/localCache";
    import DispatchDialog from '../../components/DispatchDialog/DispatchDialog'
    export default {
  name: "production",
        components:{
            DispatchDialog
        },
  data() {
    return {
      addDialogVisiable: false,
        opFlag: 'add',
      confirmVisible: false,
      formLabelWidth: '120px',
      tableData: [],
      addForm: {
        productionName:'',
        type: ''
      },
        rules: {
            productionName: [
                { required: true, message: '产品名不能为空', trigger: 'blur' },
                { min: 2, max: 32, message: '长度在 2 到 32 个字符', trigger: 'blur' }
            ],
        },
        listQuery: {
            keyword: '',
            type: -1
        },
        listLoading: true,
        selectRow: '',
      uploadLoading: '',
      uploadUrl: process.env.VUE_APP_BASE_API+'/fileupload',
      uploadParam:{
        type: 3,
      },
      selectIds: ''
    }
  },
        mounted(){
          this.uploadParam.customerId = localCache.getCurrentCustomerId()
          this.uploadParam.token = localCache.getToken()
          this.getList()
        },
  methods: {
    searchChange(){
      this.getList()
    },
    handleSelectionChange(val){
      this.selectIds = val.map(t=>t.productionId).join(',');
      console.log(this.selectIds)
    },
      addCloseHandler(){
          this.$refs['addForm'].resetFields()
          this.addForm =  {
              productionName: '',
          }
      },
    addHandler() {
        this.opFlag='add'
        this.addDialogVisiable = true
    },
    editHandler(row) {
        this.selectRow = row
        this.opFlag='edit'
        this.addForm = Object.assign({}, row)
        this.addDialogVisiable = true
    },
      addConfirm() {
          this.$refs['addForm'].validate((valid) => {
              if (!valid) {
                  return
              }
              let param = Object.assign({}, this.addForm)
              if(this.opFlag == 'add'){

              }else if(this.opFlag == 'edit'){
                  param.productionId = this.selectRow.productionId
              }
              param.customerId = localCache.getCurrentCustomerId()
              if(this.opFlag=='add'){
                  addProduction(param).then((res)=>{
                      if(res.errorcode==0){
                          this.$message.success('添加成功')
                          this.addDialogVisiable = false
                          this.getList()
                      }else{
                          this.$message.error(res.message)
                      }
                  })
              }else{
                  updateProduction(param).then((res)=>{
                      if(res.errorcode==0){
                          this.$message.success('修改成功')
                          this.addDialogVisiable = false
                          this.getList()
                      }else{
                          this.$message.error(res.message)
                      }
                  })
              }
          });
      },
      getList() {
          this.listLoading = true
          this.listQuery.customerId = localCache.getCurrentCustomerId()
          getProductionList(this.listQuery).then(res => {
              this.listLoading = false
              if (res.errorcode !== 0) {
                  this.$message.error(res.message)
              } else {
                  this.tableData = res.data
              }
          }).catch(() => {
              this.listLoading = false
          })
      },
      dispatchHandler(){
          this.$refs.dispatchDialog.open()
      },
    uploadHandler(res, file, fileList){
      if (res.errorcode !== 0) {
        this.$message.error(res.message)
      } else {
        this.$message.success('导入成功')
        this.getList()
      }
      this.uploadLoading.close()
    },
    uploadProgressHandler(event, file, fileList){
      this.uploadLoading = this.$loading({
        lock: true,
        text: '导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    }
  }
}
</script>

<style lang="scss">
.production-container{
  .t-top-bar{
    margin-bottom: 15px;
    .btns{
      float: right;
      display: flex;
      align-items: center;
      width: 350px;
      justify-content: space-between;
    }
  }
  .search-input {
    width: 350px;
  }
  .l-add-buttion{
    font-size: 35px;
    float: right;
    cursor: pointer;
  }
}
</style>
